import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: "¿Esto es terapia psicológica?",
  a: "No. Recupera Tu Vida es un proceso de mentoría y acompañamiento personal enfocado en claridad, mentalidad, relaciones, hábitos y dirección. No sustituye terapia psicológica, tratamiento médico ni atención profesional de salud mental."
}, {
  q: "¿Cuánto dura?",
  a: "El programa tiene una duración de 30 días. Durante este período tendrás una sesión estratégica 1 a 1, ejercicios, herramientas y seguimiento para avanzar paso a paso."
}, {
  q: "¿La sesión es individual?",
  a: "Sí. La sesión estratégica es completamente personalizada y tiene una duración aproximada de 60 minutos."
}, {
  q: "¿Es online?",
  a: "Sí. Todo el proceso se realiza online, por lo que puedes participar desde cualquier lugar."
}, {
  q: "¿Necesito estar atravesando una ruptura?",
  a: "No. El programa también está pensado para personas que atraviesan agotamiento emocional, estancamiento, pérdida de dirección o una etapa importante de cambio."
}, {
  q: "¿Puedo participar desde otro país?",
  a: "Sí. Al ser un programa online, puedes participar desde cualquier país."
}, {
  q: "¿Qué pasa después de los 30 días?",
  a: "Al finalizar realizaremos un diagnóstico final y recibirás un plan inicial de próximos 30 días para que puedas continuar trabajando en tu nueva dirección."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-32 bg-ink relative" data-id="element-124" data-mp="rzucnmpiedsz">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-125" data-mp="rwyhu78yk58r">
        <div className="text-center mb-16" data-id="element-126" data-mp="wz77ouqjar6n">
          <h2 className="text-3xl md:text-5xl font-serif text-ivory-bright mb-4" data-id="element-127" data-mp="wvt5pnls8jzq">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-128" data-mp="n082xn8w3fox">
          {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-xl bg-ink-light overflow-hidden" data-id="element-129" data-mp="2pmdeg7vm9mtx" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-130" data-mp="2kuc6gy5hei9p">
                <span className="font-serif text-xl text-ivory-bright" data-id="element-131" data-mp="2avwbgk3c2oux">{faq.q}</span>
                {openIndex === index ? <Minus className="w-5 h-5 text-gold shrink-0" data-id="element-132" data-mp="33mo6he8nx7go" /> : <Plus className="w-5 h-5 text-gold shrink-0" data-id="element-133" data-mp="2ynbl6xxfw8g7" />}
              </button>
              <AnimatePresence data-id="element-134" data-mp="2um0095pigbec">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-135" data-mp="2uo2oplb0lwgy">
                    <div className="px-6 pb-6 text-muted font-light leading-relaxed" data-id="element-136" data-mp="3uvhlya5vg0a2">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}